<template>
    <div class="message meta-post-message">
        <div class="meta-header" v-if="getMetaText()">
            <i class="material-icons">info</i>
            {{ getMetaText() }}
        </div>
        <div class="body">
            <div class="image-post" v-if="isImage()" @mouseenter="hovered = true" @mouseleave="hovered = false">
                <viewer :id="'imageViewer-' + getId()" :images="[imageSrc()]" v-if="imageSrc()">
                    <div
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('chatbotv2.imageView')"
                        class="cb-img-preview"
                        @click="show"
                    >
                        <img
                            :id="'img-' + getId()"
                            :src="imageSrc()"
                            class="img-thumbnail ant-upload-list-picture-card-container"
                            style="object-fit: cover"
                        />
                        <md-icon v-if="hovered" class="cb-pr-icon"> visibility</md-icon>
                    </div>
                </viewer>
            </div>
            <div class="video-post" v-else-if="isVideo()">
                <video class="video-player" controls preload="metadata" :src="videoSrc()" :poster="getVideoPoster()">
                    <source :src="videoSrc()" type="video/mp4" />
                    {{ $t("auto.videoTagNotSupported") }}
                </video>
            </div>
        </div>
        <div
            class="caption"
            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
            :content="getPostContent()"
            v-if="getPostContent().length > 0"
        >
            {{ getPostContent() }}
        </div>
        <div class="footer" v-if="!isSendDM()">
            <div class="count-stats">
                <span class="count-stat-item">{{ meta.likeCount }} <i class="material-icons">thumb_up</i></span>
                <span class="count-stat-item">{{ meta.commentCount }} <i class="material-icons">chat_bubble</i></span>
            </div>
            <span>{{ meta.timestamp }}</span>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
import moment from "moment";

Vue.use(Viewer);
export default {
    name: "MetaPostMessage",
    components: {},
    props: {
        data: {
            type: Object,
            required: true,
        },
        conversationId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    created() {
        const post = _.get(this.data, "metaPost");
        const meta = {
            caption: _.get(post, "title", ""),
            url: _.get(post, "permaLink"),
            likeCount: _.get(post, "payload.like_count", 0),
            commentCount: _.get(post, "payload.comments_count", 0),
            timestamp: moment(_.get(post, "createdDate", Date.now())).format("DD.MM.YYYY HH:mm"),
        };
        this.meta = {
            caption: meta.caption,
            url: meta.url,
            likeCount: meta.likeCount,
            commentCount: meta.commentCount,
            timestamp: meta.timestamp,
        };
    },
    data() {
        return {
            clickedButton: null,
            meta: {
                caption: "",
                url: "",
                likeCount: 0,
                commentCount: 0,
                timestamp: Date.now(),
            },
            hovered: false,
            previewImg: false,
        };
    },
    methods: {
        getPostContent() {
            return this.meta.caption || this.data.description || this.data.message || "";
        },
        isSendDM() {
            return !!_.get(this.data, "payload.type");
        },
        getMetaText() {
            const type = _.get(this.data, "metaPost.type");
            const dmType = _.get(this.data, "payload.type");
            const isInstagram = type === "instagram" || ["ig_reel", "share"].includes(dmType);
            return isInstagram ? this.$t("auto.instagramPostPreview") : this.$t("auto.facebookPostPreview");
        },
        videoSrc() {
            const asset = _.get(this.data, "metaPost.asset") || _.get(this.data, "asset");
            if (asset && asset.path) {
                return asset.v2Format && asset.cdnUrl ? asset.cdnUrl : `https://static.supsis.live/${asset.path}`;
            }
            return null;
        },
        getVideoPoster() {
            return null;
        },
        isVideo() {
            const asset = _.get(this.data, "metaPost.asset") || _.get(this.data, "asset");
            const mime = _.get(asset, "mime") || "";
            const mediaType = _.get(this.data, "metaPost.payload.media_type");
            return (mime && mime.indexOf("video") !== -1) || mediaType === "VIDEO";
        },
        getId() {
            const asset = _.get(this.data, "asset", _.get(this.data, "metaPost.asset"));
            const id = "img-" + asset?._id;
            return id;
        },
        show() {
            const id = this.getId();
            const prefixedId = "img-" + id;
            document.getElementById(prefixedId).click();
        },
        imageSrc() {
            const asset = _.get(this.data, "metaPost.asset") || _.get(this.data, "asset");
            if (asset && asset.path) {
                return asset.v2Format && asset.cdnUrl ? asset.cdnUrl : `https://static.supsis.live/${asset.path}`;
            }
            return null;
        },
        isImage() {
            const asset = _.get(this.data, "metaPost.asset") || _.get(this.data, "asset");
            const mime = _.get(asset, "mime") || "";
            return mime && mime.indexOf("image") !== -1;
        },
    },
};
</script>

<style lang="scss" scoped>
.message.meta-post-message {
    border: 1px solid;
    border-radius: 10px;
    overflow: hidden;
    width: 240px;
    border-color: rgb(219, 225, 232);
    background: rgb(255, 255, 255);

    .meta-header {
        padding: 3px;
        border-bottom: 1px solid #dbe1e8;
        font-size: 10px;
        background: #3f3f3fa1;
        color: white;
        display: flex;
        align-items: center;
        gap: 3px;

        .material-icons {
            font-size: 14px;
        }
    }

    .header-text,
    .body,
    .footer {
        background-color: #fff;
        border-radius: 4px;
        padding: 12px 8px;
    }

    .header-text {
        font-size: 16px;
        font-weight: 500;
        padding: 6px 7px 0px 9px;
        overflow-wrap: break-word;
    }

    .body {
        display: -webkit-box;
        font-size: 14px;
        font-weight: 400;
        color: rgb(63, 63, 63);
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
        overflow-y: auto;
        max-height: 400px;
        padding: 0 !important;
        white-space: pre-line;
    }

    .footer,
    .caption {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        padding: 0px 7px 8px 9px;
        color: rgb(95, 104, 128);
        overflow-wrap: break-word;
        word-break: break-word;
        display: -webkit-box;
        max-width: 100%;
        max-height: 48px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 4px;
        margin-bottom: 8px;
    }

    .footer {
        display: flex;
        justify-content: space-between;

        .material-icons {
            font-size: 14px;
            color: #1e1e2da6;
        }

        .count-stats {
            display: flex;
            gap: 5px;

            .count-stat-item {
                display: flex;
                gap: 2px;
                align-items: center;
            }
        }
    }

    .img-thumbnail {
        padding: 0;
        margin: 0;
    }
}

.video-post {
    width: 100%;
    height: auto;

    .video-player {
        width: 100% !important;
        height: auto !important;
        max-height: 300px;
        object-fit: contain;
        border-radius: 4px;
        background: #000;
        display: block;
        margin: 0 auto;
    }
}

.image-post {
    width: 100% !important;

    .cb-pr-icon {
        position: absolute;
        pointer-events: none;
    }

    .cb-img-preview {
        display: flex;
        align-items: center;
        justify-content: center;

        .cb-pr-icon {
            z-index: 2;
        }
    }

    .cb-img-preview:hover {
        cursor: pointer;
        filter: grayscale(100%);
    }

    .image-message-img {
        border-radius: 6px;
    }

    img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover;
    }
}
</style>
